import { NextHead } from "../../src/landingPage/layouts/LayoutComponents/NextHead";
import { DataApi } from "../../src/landingPage/views/DataApi/DataApi";

const DataApiPage = () => {
  return (
    <>
      <NextHead
        currentPath="/data-api/deployment-management"
        title="One Platform To Manage API Deployments"
        description="Centrally manage all your third party data APIs with the Demyst platform."
      />
      <DataApi keyword="deployment-management" />
    </>
  );
};

export const getStaticProps = () => {
  return {
    props: {
      wrapper: "MarketingWrapper",
    },
  };
};

export default DataApiPage;
